// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/card/card';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const RECOMMENDATIONS_SELECTOR = '.product-recommendations';

// Style includes
import './_product-recommendations.scss';


// -------------------------------------
// Helpers
// -------------------------------------

const initProductRecommendations = () => {
    const productRecommendations = document.querySelectorAll(RECOMMENDATIONS_SELECTOR);

    productRecommendations.forEach((productRecommendation) => {
        const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

        observer.observe(productRecommendation);
    });
};

const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    const $elem = entries[0].target;
    const url = $elem.dataset.url;

    observer.unobserve($elem);

    fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(RECOMMENDATIONS_SELECTOR);

            if (recommendations && recommendations.innerHTML.trim().length) {
                $elem.innerHTML = recommendations.innerHTML;

                $elem.querySelectorAll('.card__meta')
                    .forEach((element) => {
                        element.addEventListener('mousemove', (event) => {
                            if (window.innerWidth >= 1024) {
                                const buttonRect = element.getBoundingClientRect();
                                const xPos = event.clientX - buttonRect.left;
                                const yPos = event.clientY - buttonRect.top;
                            
                                element.style.background = `radial-gradient(circle at ${xPos}px ${yPos}px, rgba(53, 53, 53, 0.7) 0%, rgba(208, 208, 208, 0.00) 100%)`;
                            }
                        });

                        element.addEventListener("mouseleave", (event) => {
                            element.style.background = `#121212`;
                        });
                    });
            }
        })
        .catch(e => {
            console.error(e);
        });
};


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    initProductRecommendations();
});
